import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  PageSubTitle,
  Loading,
  Company
} from 'components/common/Elements/Elements';
import InputWithUnmaunt from 'components/common/forms/InputWithUnmaunt/InputWithUnmaunt';

import { getRequest } from 'utils/requests';
import { filterForArrValues, recordType } from 'utils/common';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ data, mode }) => {
  const [find, setFind] = useState('');
  const [loader, setLoader] = useState(true);
  const [customers, setCustomers] = useState([]);

  const { t } = useTranslation(['activity']);

  const handleFind = e => {
    setFind(e.target.value);
  };

  const onClearFind = useCallback(() => {
    setFind('');
  }, []);

  useEffect(() => {
    let cancelled = false;
    getRequest(`/product/fflag/logs/related/customer/list/${data}`)
      .then(res => {
        if (!cancelled) {
          setCustomers(res.body.data);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoader(false);
        }
      });
    return () => (cancelled = true);
  }, [data]);

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <PageSubTitle
        title={`${find && 'Filtered '}${
          mode === 'assign' ? 'Assigned' : 'Unassigned'
        } Customers: ${
          find
            ? filterForArrValues(customers, ['companyName', 'customerId'], find)
                .length
            : customers.length
        }`}
        className={classes.title}
        classNameHeading={classes.heading}
        size={2}
      />
      <InputWithUnmaunt
        placeholder={t('activity:filters:CUSTOMER_NAME')}
        value={find}
        onChange={handleFind}
        onClearSearch={onClearFind}
        unmauntFunc={onClearFind}
        className={classes.input}
        timeDebounce={0}
      />
      <ul className={classes.children}>
        {filterForArrValues(customers, ['companyName', 'customerId'], find).map(
          item => (
            <li key={item.customerId} className={classes.item}>
              <Company
                nameCompany={item.companyName}
                description={item.companySize}
                country={item.country}
                domain={item.website}
                status={item.status}
                recordType={recordType(item)}
                customerId={item.customerId}
              />
            </li>
          )
        )}
      </ul>
    </>
  );
};

AdditionalContent.propTypes = {
  data: PropTypes.string,
  mode: PropTypes.string
};

export default AdditionalContent;
